import { useModal } from '@mashvisor/design-system';
import ExitIntentPopup from './ExitIntentPopup';

export const useExitIntentPopup = () => {
  return useModal(
    ExitIntentPopup as React.FC<React.ComponentProps<typeof ExitIntentPopup>>,
  );
};
